import React, { useState } from 'react';
import '../App.css';
import '../css/contact.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

AOS.init();

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        city: '',
        message: ''
    });

    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const onSubmit = (e) => {
        e.preventDefault();
        toast(<div>
            <div className="row">
                <div className="col-sm-2">
                    <i className="fa fa-check-circle mt-2 text-success fa-3x"></i>
                </div>
                <div className="col-sm-10">
                    <div className="row">
                        <div className="col-sm-12">
                            <p className="text-dark float-left success-messageSize ml-1">Message delivered</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <p><small className="text-muted float-left success-subMessageSize ml-1">Your message was sent successfully</small></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>, { hideProgressBar: true, closeOnClick: true });
        
        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            city: '',
            message: ''
        });
    };

    const whyChooseUs = [
        'Over 15 years of on-ground experience',
        'Deep-rooted work ethics passed from generation to generation',
        'Tension-free, end-to-end handling of projects',
        'Transparent pricing and professional dealings',
        'Skilled workforce with detailed supervision',
        'Wide service area across Southern, Western & Northern India'
    ];

    return (
        <div className="contact-section">
            <ToastContainer />
            
            {/* Header Section */}
            <div className="container">
                <div className="row add-mobile-padding">
                    <div className="col-sm-12 col-xl-8 mt-sm-5">
                        <div className="row mt-sm-5">
                            <div data-aos="fade-right" data-aos-duration="1000" className="col-2 col-sm-1">
                                <span><hr className="slash"></hr></span>
                            </div>
                            <div className="col-10 col-sm-11">
                                <p data-aos="fade-left" data-aos-duration="1000" className="about-topic">CONTACT US</p>
                            </div>
                        </div>
                        <div className="row">
                            <p className="about-sub-topic add-margin-about-sub contact-sub-mobile">
                                <span style={{ color: '#2c3e50' }}>LET'S BUILD YOUR</span>
                                <span style={{ color: '#cd853f' }}> DREAM SPACE</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Service Areas & Description Section */}
            <div className="container mt-5">
                <div className="row">
                    {/* India Map Section */}
                    <div className="col-lg-6 mb-4">
                        <div className="service-areas-section" data-aos="fade-right" data-aos-duration="1000">
                            <h3 className="section-title">Our Service Areas</h3>
                            <div className="india-map-container">
                                <div className="india-map">
                                    <img 
                                        src={require('../images_sj/india_map.png')} 
                                        alt="India Map - Our Service Areas" 
                                        className="india-map-image"
                                        onError={(e) => {
                                            console.log('Image failed to load:', e.target.src);
                                            e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 400 500'%3E%3Ctext x='200' y='250' text-anchor='middle' fill='%23666'%3EMap Loading...%3C/text%3E%3C/svg%3E";
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="col-lg-6 mb-4">
                        <div className="description-section" data-aos="fade-left" data-aos-duration="1000">
                            <h3 className="section-title">Why Choose Shree Jeen Interiors</h3>
                            <p className="description-text">
                                We undertake projects across Southern, Western, and Northern India and offer comprehensive 
                                interior design and execution services. We treat each project as unique—planned with 
                                creativity, executed with discipline, and delivered with professionalism.
                            </p>
                            <p className="description-subtitle">
                                That's why clients trust Shree Jeen Interiors because we have:
                            </p>
                            
                            <div className="why-choose-list">
                                {whyChooseUs.map((item, index) => (
                                    <div 
                                        key={index} 
                                        className="why-choose-item"
                                        data-aos="fade-up"
                                        data-aos-delay={index * 100}
                                    >
                                        <i className="fa fa-check-circle check-icon"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Form Section */}
            {/* 
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-12">
                        <div className="contact-form-section" data-aos="fade-up" data-aos-duration="1000">
                            <div className="row">
                                <div className="col-lg-8 mx-auto">
                                    <div className="contact-form-card">
                                        <div className="form-header">
                                            <h3>Get Your Free Consultation</h3>
                                            <p>Tell us about your project and we'll get back to you within 24 hours</p>
                                        </div>
                                        
                                        <form onSubmit={onSubmit} className="modern-contact-form">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Full Name *</label>
                                                        <input 
                                                            type="text"
                                                            name="name"
                                                            value={formData.name}
                                                            onChange={handleInputChange}
                                                            required
                                                            placeholder="Enter your full name"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Email Address *</label>
                                                        <input 
                                                            type="email"
                                                            name="email"
                                                            value={formData.email}
                                                            onChange={handleInputChange}
                                                            required
                                                            placeholder="Enter your email"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Phone Number *</label>
                                                        <input 
                                                            type="tel"
                                                            name="phone"
                                                            value={formData.phone}
                                                            onChange={handleInputChange}
                                                            required
                                                            placeholder="Enter your phone number"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>City *</label>
                                                        <select 
                                                            name="city"
                                                            value={formData.city}
                                                            onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="">Select your city</option>
                                                            <option value="Delhi">Delhi</option>
                                                            <option value="Mumbai">Mumbai</option>
                                                            <option value="Pune">Pune</option>
                                                            <option value="Bangalore">Bangalore</option>
                                                            <option value="Other">Other</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="form-group">
                                                <label>Project Details *</label>
                                                <textarea 
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleInputChange}
                                                    required
                                                    rows="4"
                                                    placeholder="Tell us about your project requirements, timeline, and budget"
                                                ></textarea>
                                            </div>
                                            
                                            <div className="form-submit">
                                                <button type="submit" className="submit-btn">
                                                    <span>Get Free Consultation</span>
                                                    <i className="fa fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            */}

            {/* Contact Info Section */}
            <div className="container mb-5">
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="contact-info-card" data-aos="fade-up" data-aos-delay="0">
                            <div className="info-icon">
                                <i className="fa fa-map-marker"></i>
                            </div>
                            <h4>Visit Our Office</h4>
                            <p>Ground floor, No-78, 5th Cross,<br/>
                               Subramani Layout, Ramamurthy<br/>
                               Nagar, Bangalore - 560016</p>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="contact-info-card" data-aos="fade-up" data-aos-delay="200">
                            <div className="info-icon">
                                <i className="fa fa-phone"></i>
                            </div>
                            <h4>Call Us</h4>
                            <p><a href="tel:+91-9828544225">+91-9828544225</a><br/>
                               Available 9 AM - 10 PM<br/>
                               All Days</p>
                        </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 mb-4">
                        <div className="contact-info-card" data-aos="fade-up" data-aos-delay="400">
                            <div className="info-icon">
                                <i className="fa fa-envelope"></i>
                            </div>
                            <h4>Email Us</h4>
                            <p><a href="mailto:shreejeeninteriors09@gmail.com">shreejeeninteriors09@gmail.com</a><br/>
                               Quick response within<br/>
                               24 hours</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;



